import styled from "styled-components";


export const WrapperBundle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: ${props => props.styleProps.wrapperBundleWidth};
    height: 27px;
    margin-bottom: 6px;
`
export const WrapperInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: ${props => props.styleProps.wrapperInfoWidth};
`
export const BundleLink = styled.a`
    width: ${props => props.styleProps.wrapperInfoWidth};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

export const WrapperBundleName = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
`
export const BundleName = styled.span`
    font-size: 13px;
    font-weight: bold;
    text-align: left;
    letter-spacing: -0.71px;
    line-height: 18px;
    color: #333333;
    margin: 0px;
`
export const BundleRankingLabel = styled.span`
    font-size: 9px;
    font-weight: bold;
    text-align: center;
    letter-spacing: -0.5px;
    line-height: 20px;
    color: #3281ED;
    border: 1px solid #3281ED;
    margin: 0px 0px 0px 3.5px;
    width: 19px;
    height: 14px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

export const WrapperBundlePrice = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
`
export const BundlePrice = styled.span`
    font-size: 15px;
    font-weight: bold;
    text-align: right;
    letter-spacing: -0.23px;
    line-height: 18px;
    color: #f34522;
    margin: 0px;
`
export const BundlePriceUnit = styled.span`
    font-size: 12px;
    text-align: left;
    line-height: 18px;
    color: #999999;
    margin: 0px 2px 0px 2px;
`

export const BundleMallCount = styled.span`
    font-size: 12px;
    text-align: right;
    letter-spacing: -0.8px;
    line-height: 18px;
    color: #999999;
    margin: 0px 0px 0px 5px;
    width: 36px;
`
export const WrapperButtonGroup = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    width: ${props => props.styleProps.wrapperButtonGroupWidth};
    padding : ${props => props.styleProps.wrapperButtonGroupPadding};
`
export const BundleStatus= styled.span`
    font-size: 12px;
    text-align: right;
    letter-spacing: -0.18px;
    line-height: 18px;
    color: #999999;
    position: relative;
    right: ${props => props.styleProps.BundleStatusRight};
    font-weight: bold;
`







// WEBPACK FOOTER //
// ./src/estimate_list/components/list/bundleGroup/bundleItem/bundleItem.style.js